var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21437"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17704",
    d: "M11 6.114v11.555m0-11.555A7.292 7.292 0 0 0 7 5a7.292 7.292 0 0 0-4 1.114v11.555a7.292 7.292 0 0 1 4-1.114 7.292 7.292 0 0 1 4 1.114m0-11.555A7.292 7.292 0 0 1 15 5a7.29 7.29 0 0 1 4 1.114v11.555a7.29 7.29 0 0 0-4-1.114 7.292 7.292 0 0 0-4 1.114",
    transform: "translate(1.5 .5)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 19829",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEBook);
export default __webpack_public_path__ + "static/media/e-book.7b52b647b0df7efc336825861e17643b.svg";
export { ForwardRef as ReactComponent };